"use strict";
// Copyright (c) StrangeBee 2023
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionController = exports.GenericErrorInvoke = void 0;
const ParentController_1 = __importDefault(require("../ParentController"));
class GenericErrorInvoke extends Error {
    constructor(...params) {
        const [errorCode, message, status] = params;
        super(message);
        this.errorCode = errorCode;
        this.status = status;
    }
}
exports.GenericErrorInvoke = GenericErrorInvoke;
class FunctionController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: 'v1/function',
            edit: 'v1/function/:objectId',
            delete: 'v1/function/:objectId',
            invoke: 'v1/function/:objectId',
            test: 'v1/function/_test',
            documentation: 'v1/function/_context/documentation',
        };
    }
    invoke(objectId) {
        return this.manager.post({
            url: this.endpoints.invoke,
            params: { objectId },
        });
    }
    test(data) {
        const _a = data || {}, { dryRun = false } = _a, body = __rest(_a, ["dryRun"]);
        return this.manager.post({
            url: `${this.endpoints.test}${dryRun ? '?dryRun' : ''}`,
        }, body);
    }
    getDocumentation() {
        return this.manager.get({ url: this.endpoints.documentation });
    }
}
exports.FunctionController = FunctionController;
